export default __webpack_public_path__ + "static/media/cssda-ux-Ronnie-Feng.e8ddf522.webp";